import { Form, Formik } from "formik";
import closeIcon from "../../assets/icons/close-icon.svg";
import FilterTextField from "./filter-input-fields/filter-text-field";
import { FilterDropDown } from "./filter-input-fields/filter-dropdown";
import { FilterMultiDropDown } from "./filter-input-fields/filter-multi-dropdown";
import { FilterToggleSwitch } from "./filter-input-fields/filter-switch";
import { FilterFromToDateField } from "./filter-input-fields/filter-from-to-field";
import { uiTypes } from "../../utils/types";
import { useLocation, useNavigate } from "react-router-dom";
import {
  FormDropDownDynamic,
  FormMultiDropDownDynamic,
} from "../form/dynamic-dropdown";
import { FormDropDown, FormMultiSelectDropDown } from "../form/dropdown";
import queryString from "query-string";
import { FormToggleSwitch } from "../form/checkbox";

const FilterDrawer = ({ open, onClose = () => {}, columns, references }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const columnHeadings = () => {
    var array = [];
    for (var i = 0; i < columns.length; i++) {
      var column = columns[i];
      if (column.ui?.list == null || column.ui.list == true) {
        array.push(column.name);
      }
    }
    return array;
  };

  const headings = columnHeadings();

  const parsed = queryString.parse(location.search, { arrayFormat: "bracket" });

  const nestedParsed = {};
  for (const [key, value] of Object.entries(parsed)) {
    const match = key.match(/^(\w+)\[(\w+)\]$/);
    if (match) {
      const [, mainKey, subKey] = match;
      if (!nestedParsed[mainKey]) nestedParsed[mainKey] = {};
      nestedParsed[mainKey][subKey] = value;
    } else {
      nestedParsed[key] = value;
    }
  }

  const initialValues = columns.reduce((data, column) => {
    if (column.ui?.list == null || column.ui.list === true) {
      const name = column.name;
      const value = nestedParsed[name];
      data[name] = value ?? "";
    }
    return data;
  }, {});

  const handleSubmit = (values) => {
    console.log(values, "values");

    const cleanedValues = Object.fromEntries(
      Object.entries(values).filter(([key, value]) => {
        if (value === false) return false; // Exclude false values
        if (Array.isArray(value)) return value.length > 0;
        if (typeof value === "object" && value !== null) {
          return Object.values(value).some(
            (v) => v !== undefined && v !== null && v !== "" && v !== false
          );
        }
        return (
          value !== undefined &&
          value !== null &&
          value !== "" &&
          value !== false
        );
      })
    );

    const flattened = {};
    for (const [key, value] of Object.entries(cleanedValues)) {
      if (
        typeof value === "object" &&
        !Array.isArray(value) &&
        value !== null
      ) {
        for (const [subKey, subVal] of Object.entries(value)) {
          if (
            subVal !== false &&
            subVal !== undefined &&
            subVal !== null &&
            subVal !== ""
          ) {
            flattened[`${key}[${subKey}]`] = subVal;
          }
        }
      } else {
        flattened[key] = value;
      }
    }

    const searchParams = queryString.stringify(flattened, {
      arrayFormat: "bracket",
    });

    console.log("searchParams", searchParams);

    navigate(`${location.pathname}?${searchParams}`);
    onClose();
  };

  const clearFilter = () => {
    navigate(`${location.pathname}`);
    onClose();
  };

  const enumToOptions = (enumValues = []) =>
    enumValues.map((val) => ({
      label: val.charAt(0).toUpperCase() + val.slice(1),
      value: val,
    }));

  console.log(initialValues, parsed, "initialValues");

  return (
    <div
      className={`
          fixed top-0 right-0 h-full w-full max-w-[30rem] bg-white shadow-lg z-50 p-5
          transform transition-transform duration-300 ease-in-out
          ${open ? "translate-x-0" : "translate-x-full"}
        `}
    >
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        enableReinitialize={true}
      >
        {({ values, resetForm }) => (
          <Form>
            <div className="flex items-center justify-between w-full">
              <h3 className="text-lg font-bold mb-4">Filters</h3>
              <button
                type="button"
                className="p-1 bg-gray-100 rounded-full"
                onClick={onClose}
              >
                <img src={closeIcon} alt="X" width={24} height={24} />
              </button>
            </div>

            <div className="h-screen max-h-[calc(100vh-10rem)] overflow-auto">
              <div>
                {headings.map((heading) => {
                  var column = columns.find((value) => value.name == heading);
                  if (column?.ui?.list && column?.ui?.type === uiTypes?.TEXT) {
                    return (
                      <FilterTextField
                        name={heading}
                        label={heading}
                        placeholder={`Enter ${heading}`}
                      />
                    );
                  }
                  if (
                    (column.ui?.list === null || column?.ui?.list === true) &&
                    column?.ui?.type === uiTypes?.SWITCH
                  ) {
                    return (
                      <FormToggleSwitch
                        name={heading}
                        label={heading}
                        value={values?.[heading]}
                      />
                    );
                  }

                  if (
                    column?.ui?.list &&
                    column?.ui?.type === uiTypes?.DROPDOWN
                  ) {
                    if (!column?.enumValues) {
                      var reference = references.find(
                        (value) => value.foreignKey == heading
                      );
                      return (
                        <FormDropDownDynamic
                          name={heading}
                          label={heading}
                          reference={reference}
                          placeholder="Select"
                          value={enumToOptions(column?.enumValues)?.find(
                            (item) => item?.value === values?.[heading]
                          )}
                        />
                      );
                    }

                    return (
                      <FormDropDown
                        name={heading}
                        label={heading}
                        options={enumToOptions(column?.enumValues)}
                        value={enumToOptions(column?.enumValues)?.find(
                          (item) => item?.value === values?.[heading]
                        )}
                      />
                    );
                  }

                  if (
                    column?.ui?.list &&
                    column?.ui?.type === uiTypes?.DROPDOWN_MULTISELECT
                  ) {
                    if (!column?.enumValues) {
                      var reference = references.find(
                        (value) => value.foreignKey == heading
                      );
                      return (
                        <FormMultiDropDownDynamic
                          name={heading}
                          label={heading}
                          reference={reference}
                          placeholder="Select"
                          value={enumToOptions(column?.enumValues)?.filter(
                            (item) => values?.[heading]?.includes(item.value)
                          )}
                        />
                      );
                    }

                    return (
                      <FormMultiSelectDropDown
                        name={heading}
                        label={heading}
                        options={enumToOptions(column?.enumValues)}
                        value={enumToOptions(column?.enumValues)?.filter(
                          (item) => values?.[heading]?.includes(item.value)
                        )}
                      />
                    );
                  }

                  if (column?.ui?.list && column?.ui?.type === uiTypes?.DATE) {
                    return (
                      <FilterFromToDateField
                        name={heading}
                        label={heading}
                        fromValue={`${values?.[heading]?.from}`}
                        toValue={`${values?.[heading]?.to}`}
                      />
                    );
                  }

                  if (
                    column?.ui?.list &&
                    column?.ui?.type === uiTypes?.DATE_TIME
                  ) {
                    return (
                      <FilterFromToDateField
                        name={heading}
                        label={heading}
                        fromValue={`${values?.[heading]?.from}`}
                        toValue={`${values?.[heading]?.to}`}
                        type="datetime-local"
                      />
                    );
                  }

                  if (column?.ui?.type == uiTypes.IMAGE) {
                    return null;
                  }
                  return (
                    <>
                      {column?.ui?.list && (
                        <FilterTextField
                          label={heading}
                          name={heading}
                          placeholder={`Enter ${heading}`}
                        />
                      )}
                    </>
                  );
                })}
              </div>
            </div>
            <div className="flex justify-end gap-2 p-2 mt-2">
              <button
                type="submit"
                className="px-4 py-2 bg-blue-600 text-white rounded"
              >
                Apply Filters
              </button>
              <button
                onClick={() => {
                  clearFilter();
                  resetForm();
                }}
                type="button"
                className="px-4 py-2 bg-secondary text-white rounded"
              >
                Clear Filters
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default FilterDrawer;
